import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Organizacion } from "@/shared/types/organizacion";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface OrganizacionHabilitadoRequest {
  habilitado: boolean,
}

export async function setOrganizacionHabilitado(id: string, request: OrganizacionHabilitadoRequest): Promise<Organizacion> {
  await sleep(1000);
  const response = await api.put("organizaciones/" + id + "/habilitado", request);
  return response.data;
}

export function useSetOrganizacionHabilitadoMutation(id: string, mutationConfig: MutationConfig<Organizacion, OrganizacionHabilitadoRequest> = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    ...mutationConfig,
    mutationFn: async (request: OrganizacionHabilitadoRequest) => await setOrganizacionHabilitado(id, request),
    onSuccess: (...args) => {
      mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
      queryClient.invalidateQueries({ queryKey: ["organizaciones"] });
    },
  })
}

export interface SetOrganizacionHabilitadoMutationProps {
  id: string,
  mutationConfig?: MutationConfig<Organizacion, OrganizacionHabilitadoRequest>,
  children?: (mutationResult: MutationResult<Organizacion, OrganizacionHabilitadoRequest>) => ReactNode
}

export function SetOrganizacionHabilitadoMutation({
  id,
  children,
  mutationConfig
}: SetOrganizacionHabilitadoMutationProps) {
  const mutationResult = useSetOrganizacionHabilitadoMutation(id, mutationConfig);
  return children && children(mutationResult)
}
